<ng-template #requestEventContent let-modal>
    <div class="modal-header" style="padding: 10px;">
        <h6 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">
            {{'request-event-modal.request-event' | translate}}</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="font-size: 12px;">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <app-form-group-input [label]="'request-event-modal.event-name' | translate"
                            [(model)]="event.eventName"></app-form-group-input>
                    </div>
                    <div class="col">
                        <app-client-select-modal (clientSelected)="onClientSelectedEvent($event)">
                        </app-client-select-modal>
                    </div>
                    <div class="col form-group">
                        <label>Language</label>
                        <select class="form-control form-control-sm" [(ngModel)]="event.language">
                            <option *ngFor="let language of clientLanguageArray" [value]="language.value">
                                {{language.label}}
                            </option>
                        </select>
                    </div>
                    <div class="col form-group">
                        <label>Village</label>
                        <ng-select [items]="villageOptions" class="custom" [(ngModel)]="event.village"></ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-form-group-datepicker [label]="'request-event-modal.start-date' | translate"
                            [(model)]="startDate"></app-form-group-datepicker>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <app-form-group-datepicker [label]="'request-event-modal.pickup-date' | translate"
                                    [(model)]="pickUpDate"></app-form-group-datepicker>
                            </div>
                            <div class="col">
                                <app-form-group-timepicker [label]="'request-event-modal.pickup-time' | translate"
                                    [(ngModel)]="event.pickUpTime"></app-form-group-timepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <app-form-group-datepicker [label]="'request-event-modal.end-date' | translate"
                            [(model)]="endDate"></app-form-group-datepicker>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <app-form-group-datepicker [label]="'request-event-modal.return-date' | translate"
                                    [model]="returnDate"></app-form-group-datepicker>
                            </div>
                            <div class="col">
                                <app-form-group-timepicker [label]="'request-event-modal.return-time' | translate"
                                    [model]="event.returnTime"></app-form-group-timepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col">
                <h4 style="margin-top: 0px;">{{'request-event-modal.software' | translate}}</h4>
                <div class="row">
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.waiters' | translate"
                            [(model)]="waiterQuantity" (modelChange)="phoneQuantity = waiterQuantity">
                        </app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cash-register' | translate"
                            [(model)]="cashRegisterQuantity"
                            (modelChange)="tabletQuantity = (mainDeviceQuantity + cashRegisterQuantity)">
                        </app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.main-device' | translate"
                            [(model)]="mainDeviceQuantity"
                            (modelChange)="tabletQuantity = (mainDeviceQuantity + cashRegisterQuantity)">
                        </app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.printers' | translate"
                            [(model)]="printerSoftwareQuantity"
                            (modelChange)="printerQuantity = printerSoftwareQuantity"></app-form-group-number-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h4 style="margin-top: 0px;">{{'request-event-modal.hardware' | translate}}</h4>
                <div class="row">
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.phones' | translate"
                            [(model)]="phoneQuantity"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.printers' | translate"
                            [(model)]="printerQuantity"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.routers' | translate"
                            [(model)]="routerQuantity"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.ups' | translate"
                            [(model)]="upsQuantity"></app-form-group-number-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cable-1m' | translate"
                            [(model)]="cableQuantity.one"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cable-5m' | translate"
                            [(model)]="cableQuantity.five"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cable-10m' | translate"
                            [(model)]="cableQuantity.ten"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cable-20m' | translate"
                            [(model)]="cableQuantity.twenty"></app-form-group-number-input>
                    </div>
                    <div class="col">
                        <app-form-group-number-input [label]="'request-event-modal.cable-50m' | translate"
                            [(model)]="cableQuantity.fifty"></app-form-group-number-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark"
            (click)="submitNewEventRequest()">{{'request-event-modal.save' | translate}}</button>
    </div>
</ng-template>

<button class="btn btn-sm btn-outline-primary" style="margin:0px;" (click)="open(requestEventContent)"><i
        class="fa fa-calendar-check"></i></button>
